import React, { useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Loader } from '@mantine/core';
import { Context as AuthContext } from '../../../providers/AuthContextProvider';
import VendorSetupGuideView from './VendorSetupGuideView';
import VendorAnalyticsView from './VendorAnalyticsView';
import AppStack from '../../common/AppStack';

const VendorDashboardOverview = () => {
  const { state: authState } = useContext(AuthContext);
  const ecomVendor = authState.ecomVendors.find(
    (v) => v.pkEcomVendor.toString() === authState.pkEcomVendor?.toString()
  );

  return !ecomVendor ? (
    <AppStack
      style={{
        flex: 1,
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Loader color="dark" size="xl" />
    </AppStack>
  ) : (
    <Routes>
      {!ecomVendor?.sandboxEnabled ? (
        <>
          <Route element={<VendorAnalyticsView />} path="/" />
          <Route element={<VendorSetupGuideView />} path="/setup-guide" />
        </>
      ) : (
        <>
          <Route element={<VendorSetupGuideView />} path="/" />
          <Route element={<VendorSetupGuideView />} path="/setup-guide" />
        </>
      )}
      <Route element={<Navigate replace to="/vendor" />} path="*" />
    </Routes>
  );
};

export default VendorDashboardOverview;
